module.exports = __webpack_public_path__ + "zw.svg?58e2cbd64ee1252a407f1ca815b6817f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/zw.svg
// module id = 1706
// module chunks = 0